"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: adjust the imports and remove the need for re-exporting
const math_1 = require("@mat3ra/code/dist/js/math");
exports.default = {
    ...math_1.math,
};
